import React from 'react';
import { PackagingCardSkeleton } from './PackagingCardSkeleton';

export const PackagingGridSkeleton = React.memo(() => {
  const skeletonCount = 12;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
      {Array.from({ length: skeletonCount }).map((_, index) => (
        <PackagingCardSkeleton key={`skeleton-${index}`} />
      ))}
    </div>
  );
});

PackagingGridSkeleton.displayName = 'PackagingGridSkeleton';

export default PackagingGridSkeleton;
